export const types = {
    SET_CURRENT_ROUTE: "SET_CURRENT_ROUTE",
    ERROR_500: "ERROR_500",
    CLEAR_ERROR_500: "CLEAR_ERROR_500",
};